import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const QUIZ_OUTCOME_FRAMING_I18N_NAMESPACE =
  '@mc/next/experiments/pen-5819_v1_quiz_outcome_framing'

export const i18nInstance = registerI18nResources({
  namespace: QUIZ_OUTCOME_FRAMING_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
